import React from 'react';

const ToolbarDivider = () => {
	return (
		<div
			style={{
				width: 2,
				backgroundColor: '#eee',
				marginLeft: 8,
				marginRight: 8,
				display: 'flex',
				alignSelf: 'stretch',
				marginTop: 8,
				marginBottom: 8
			}}
		/>
	);
};
export default ToolbarDivider;
